import { RecentSearch, SearchType } from '@interfaces/header'

const RECENT_SEARCHES_KEY = 'acko_recent_searches'

export const saveRecentSearch = (query: string, type: SearchType): void => {
  if (typeof window === 'undefined') return

  try {
    const recentSearches = getRecentSearches()
    const newSearch: RecentSearch = {
      query,
      timestamp: Date.now(),
      type,
    }

    const filteredSearches = recentSearches.filter(search => search.query.toLowerCase() !== query.toLowerCase())

    const updatedSearches = [newSearch, ...filteredSearches].slice(0, 5)

    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(updatedSearches))
  } catch (error) {
    console.error('Error saving recent search:', error)
  }
}

export const getRecentSearches = (type?: SearchType): RecentSearch[] => {
  if (typeof window === 'undefined') {
    return []
  }

  try {
    const stored = localStorage.getItem(RECENT_SEARCHES_KEY)
    let allSearches: RecentSearch[] = stored ? JSON.parse(stored) : []

    const now = Date.now()
    const expiryTime = 15 * 24 * 60 * 60 * 1000

    allSearches = allSearches.filter(search => now - search.timestamp < expiryTime)

    if (type) {
      return allSearches.filter(search => search.type === type)
    }

    return allSearches
  } catch (error) {
    console.error('Error getting recent searches:', error)
    return []
  }
}

export const clearRecentSearches = (type?: SearchType): void => {
  if (typeof window === 'undefined') return

  try {
    if (type) {
      const allSearches = getRecentSearches()
      const filteredSearches = allSearches.filter(search => search.type !== type)
      localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(filteredSearches))
    } else {
      localStorage.removeItem(RECENT_SEARCHES_KEY)
    }
  } catch (error) {
    console.error('Error clearing recent searches:', error)
  }
}
